import React from 'react';
import PropTypes from 'prop-types';
import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';
import { styled } from '@uhg-abyss/web/tools/styled';

const MAX_LICENSE = 5;
const RemoveIcon = styled('span', {
  fontSize: 'initial',
  fontWeight: 'bold',
  marginRight: '25px',
  cursor: 'pointer',
  color: 'rgb(25, 110, 207)',
  bottom: '5%',
});
const AlignRemoveText = styled('span', {
  marginLeft: '2px',
  verticalAlign: 'text-bottom',
});

export const AddLicenseServicing = ({ licenseCount, handleAddNewLicense }) => {
  return (
    <RemoveIcon
      id="license-Remove-button"
      onClick={() => {
        if (licenseCount < MAX_LICENSE) {
          handleAddNewLicense();
        }
      }}
      style={{
        color: licenseCount === MAX_LICENSE ? 'rgb(229, 229, 229)' : '',
        cursor: licenseCount === MAX_LICENSE ? 'not-allowed' : 'pointer',
      }}
      isDisabled={licenseCount === MAX_LICENSE}
    >
      <IconSymbol
        id="license-add-button"
        style={{
          color: licenseCount === MAX_LICENSE ? 'rgb(229, 229, 229)' : '',
        }}
        size={20}
        icon="add_circle_outline"
      />
      <AlignRemoveText>Add additional license</AlignRemoveText>
    </RemoveIcon>
  );
};

AddLicenseServicing.propTypes = {
  licenseCount: PropTypes.number.isRequired,
  handleAddNewLicense: PropTypes.func.isRequired,
};
